import { Auth } from 'aws-amplify'
import HttpRepository from './httpRepository'

export default class AuthRepository extends HttpRepository {
  async signup({ email, lastName, firstName, password }) {
    await Auth.signUp({
      username: email,
      password,
      attributes: {
        email,
        family_name: lastName,
        given_name: firstName
      }
    })
  }

  async verifyCodeAndSignin({ email, code, password }) {
    await Auth.confirmSignUp(email, code)
    const res = await Auth.signIn(email, password)
    const token = res.signInUserSession.idToken.jwtToken

    this.axios.setHeader('X-Authorization', token)

    await this.post('/v1/user/register')
    return token
  }

  async verifyCode({ email, code }) {
    await Auth.confirmSignUp(email, code)
  }

  async resendVerifyCode({ email }) {
    await Auth.resendSignUp(email)
  }

  async login({ email, password }) {
    const res = await Auth.signIn(email, password)
    const token = res.signInUserSession.idToken.jwtToken
    this.axios.setHeader('X-Authorization', token)
    await this.post('/v1/user/register')
    return token
  }

  async logout() {
    this.axios.setHeader('X-Authorization', undefined)
    await Auth.signOut().catch()
  }

  async resetPassword(email) {
    await Auth.forgotPassword(email)
  }

  async confirmResetPassword(email, code, password) {
    await Auth.forgotPasswordSubmit(email, code, password)
  }

  async getCurrentUserInfo() {
    const data = await this.get('/v1/user/info')
    return data.result
  }

  async uploadCertification(file) {
    const params = new URLSearchParams()
    params.append('user', file)
    await this.post(`/v1/user/upload`, params)
  }
}
